import { Injectable } from '@angular/core';
import { Allocation } from '@app/dashboard/sheets/shared/ea-simulation-packs/simulation-pack.service';
import { API_ROUTE_SUPPORTS_SEARCH } from '@app/forms/subscription/api/api-router';
import { HttpApiService } from '@app/providers/http-api/http-api.service';
import * as _ from 'lodash';
import { map, Observable } from 'rxjs';

export interface VersementPackResolvedLine {
  id: number;
  name: string;
  type: string;
  isin: string;
  isr: boolean;
  details: any;
  allocationPercentage: number;
}

export interface VersementPackResolution {
  lines: VersementPackResolvedLine[];
  unresolvedIsins: string[];
}

@Injectable({ providedIn: 'root' })
export class VersementPackSupportsService {
  constructor(private httpApi: HttpApiService) {}

  resolve(
    allocation: Allocation[],
    productId: number,
  ): Observable<VersementPackResolution> {
    const isins = _.compact(_.map(allocation, 'supportIsin'));

    return this.httpApi
      .post(API_ROUTE_SUPPORTS_SEARCH, {
        page: 1,
        size: isins.length || 1,
        isins,
        lifeInsuranceId: productId,
        active: true,
        fillFullData: true,
      })
      .pipe(
        map((res: any) => {
          const supportsByIsin = _.keyBy(res?.content || [], 'isin');

          const lines: VersementPackResolvedLine[] = [];
          const unresolvedIsins: string[] = [];

          allocation.forEach((item: any) => {
            const support = supportsByIsin[item.supportIsin];
            if (!support) {
              unresolvedIsins.push(item.supportIsin);
              return;
            }
            lines.push({
              id: support.id,
              name: support.name,
              type: support.type,
              isin: support.isin,
              isr: support.isr,
              details: support.details,
              allocationPercentage: Number(item.allocationPercentage) || 0,
            });
          });

          return { lines, unresolvedIsins };
        }),
      );
  }
}
